import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { UserService } from '../services/user.service';
import { CheckEmail } from '../services/validators/check-email.validator';
import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    animations: [fadeInUp]
})
export class ForgotPasswordPageComponent implements OnInit {

    forgotPasswordForm: FormGroup;
    formSubmitted: Boolean = false;

    constructor(
        private fbuilder: FormBuilder,
        private userService: UserService
    ) {
        this.forgotPasswordForm = fbuilder.group({
            'email': [null, Validators.compose([Validators.required, CheckEmail])]
        });
    }

    ngOnInit() {
    }

    submitForgotPasswordForm(isValid: boolean, submission) {
        if (isValid) {
            this.formSubmitted = true;
            this.userService.forgotPassword(submission).then(result => {
            }).catch(error => {
            })
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/login/forgot-password.component.ts